<template>
  <div
    :class="[
      'tw-w-full tw-flex tw-flex-col tw-relative tw-h-full',
      'tw-overflow-auto scrollbar-hide',
    ]"
  >
    <div
      :class="[
        'tw-text-h3-bold-mobile apTablet2:tw-text-h3-bold-desktop',
        'tw-mt-8 tw-mb-[64px]',
      // 'dark:tw-text-white'
      ]"
    >What is the budget for your project?</div>
    <label class="tw-text-body-bold-mobile apTablet2:tw-text-body-bold-desktop tw-pb-6">Please select one:</label>
    <div class="tw-grid tw-grid-cols-1 apDesktop:tw-grid-cols-2 tw-gap-4 tw-pb-4">
      <SelectForm
        v-for="option in options"
        :key="option"
        :value="option"
        :has-subtitle="true"
        :selected="selectedOption === option"
        @click="onClickBudget(option)"
      />
    </div>
    <div class="tw-grid tw-grid-cols-1 apDesktop:tw-grid-cols-2 tw-gap-4 tw-pt-[72px]">
      <DatepickerForm
        v-model:date="contactUs.ideal_go_live_date"
        title="What is your ideal go-live date?"
        :placeholder="'Please select date'"
        @select-date="onSelectDate"
      />
    </div>
    <div class="apDesktop:tw-mb-[64px] tw-mb-[78px] tw-mt-[76px]">
      <NextButton label="Next" :enable="activeNextButton" @click="emit('clickNext')" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { ContactUs } from '../../model/interfaces/ContactUs';
import DatepickerForm from '../shared/DatepickerForm.vue';
import SelectForm from '../shared/SelectForm.vue';
import NextButton from './NextButton.vue';

const props = defineProps < {
  contactUs: ContactUs
} > ();

const emit = defineEmits(['clickNext']);
const selectedOption = ref('');
const activeNextButton = ref(false);
const options = ref([
  'Small: US$ 10,000 — US$ 20,000',
  'Medium: US$ 20,000 — US$ 50,000',
  'Large: US$ 50,000 — US$ 100,000',
  'Enterprise: US$ 100,000 or more',
]);

onMounted(() => {
  if (props.contactUs.budget !== '') {
    selectedOption.value = props.contactUs.budget;
  }
});

function onClickBudget(item: string) {
  if (selectedOption.value === item) {
    selectedOption.value = '';
  }else{
    selectedOption.value = item;
  }
}

watch(selectedOption, () => {
  props.contactUs.budget = selectedOption.value;
  activeNextButton.value = props.contactUs.isValidIdealGoLiveDate() && props.contactUs.isValidBudget();
});

function onSelectDate() {
  activeNextButton.value = props.contactUs.isValidIdealGoLiveDate() && props.contactUs.isValidBudget();
}

</script>

<style scoped>
.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
</style>